<template>
<component
  :is="item.component"
  :key="item.key"
  v-bind="$attrs"
  :params="item.params"
  :index="ii"
  :active="ii==routeComponents.length-1"
  v-for="(item, ii) in routeComponents"
  xxv-show="ii==routeComponents.length-1" />
</template>

<script>
export default {
  inheritAttrs: false,
  computed: {
    routeComponents() {
      var foundRoutes=[];
      var config=this.stores.config.config;

      var path=(this.$route.params.path || []).slice();
      var parsedComponents=[];
      while(path.length) {
        var pathType=path.shift();
        parsedComponents.push(pathType);
        if (config.customRoutes[pathType]) {
          foundRoutes.push({
            component: config.customRoutes[pathType].listComponent,
            key: "/"+parsedComponents.join("/"),
            params: {type: pathType, path: "/"+parsedComponents.join("/")},
          });
          if (path.length) {
            var pathParam=path.shift();
            parsedComponents.push(pathParam);
            foundRoutes.push({
              component: config.customRoutes[pathType].itemComponent,
              key: "/"+parsedComponents.join("/"),
              params: {type: pathType, id: pathParam, path: "/"+parsedComponents.join("/")},
            });
          }
        } else if(pathType=="File") {
          foundRoutes.push({
            component: "DataFiles",
            key: "/"+parsedComponents.join("/"),
            params: {type: pathType, path: "/"+parsedComponents.join("/")},
          });
          if (path.length) {
            var pathParam=path.shift();
          }
        } else if(pathType=="ExtDoc") {
          foundRoutes.push({
            component: "DataExtDoc",
            key: "/"+parsedComponents.join("/"),
            params: {type: pathType, path: "/"+parsedComponents.join("/")},
          });
          if (path.length) {
            var pathParam=path.shift();
          }
        } else if(pathType=="ToDo") {
          foundRoutes.push({
            component: "DataToDo",
            key: "/"+parsedComponents.join("/"),
            params: {type: pathType, path: "/"+parsedComponents.join("/")},
          });
          if (path.length) {
            var pathParam=path.shift();
          }
        } else if(pathType.startsWith("Report")) {
          foundRoutes.push({
            component: pathType,
            key: "/"+parsedComponents.join("/"),
            params: {type: pathType, path: "/"+parsedComponents.join("/")},
          });
          if (path.length) {
            var pathParam=path.shift();
          }
        } else if(config.data[pathType]) {
          foundRoutes.push({
            component: "DataList",
            key: "/"+parsedComponents.join("/"),
            params: {type: pathType, path: "/"+parsedComponents.join("/")},
          });
          if (path.length) {
            var pathParam=path.shift();
            parsedComponents.push(pathParam);
            foundRoutes.push({
              component: "DataEdit",
              key: "/"+parsedComponents.join("/"),
              params: {type: pathType, id: pathParam, path: "/"+parsedComponents.join("/")},
            });
          }
        } else {
          return [{
            component: "NotFound",
            key: this.$route.fullPath,
            params: {}
          }];
        }
      }

      if (foundRoutes.length)
        return foundRoutes;
      else
        return [{
          component: "NotFound",
          key: this.$route.fullPath,
          params: {}
        }];
    },
  },
  created() {
    if (this.$route.params.path=="") {
      var homeRoute=this.stores.config.config.homeRoute;
      if (homeRoute)
        return this.$router.replace({name: "page", params: {path: homeRoute.filter(a=>a)}});
    }
  },
}
var dynamicRouterMixin={

}
export { dynamicRouterMixin }
</script>
